module.exports = __webpack_public_path__ + "img/blank.8c37944.png";